import { render, staticRenderFns } from "./GroupInfoPanel.vue?vue&type=template&id=f4f8fd5c&scoped=true"
import script from "./GroupInfoPanel.vue?vue&type=script&lang=js"
export * from "./GroupInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./GroupInfoPanel.vue?vue&type=style&index=0&id=f4f8fd5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f8fd5c",
  null
  
)

export default component.exports